import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ResolverService } from 'src/app/___LOGIC/__common/resolver.service';
import { GuiFlowService } from 'src/app/___LOGIC/__gui/gui-flow.service';
import { ShopifyService } from 'src/app/___LOGIC/__shopify/shopify.service';
import { interval, Subscription } from "rxjs";
import { ApiConnectorService } from 'src/app/___LOGIC/__api/api-connector.service';
import { OrdersService } from 'src/app/___LOGIC/__orders/orders.service';
import { VisaDataProviderService } from 'src/app/___LOGIC/__data/__apps/visa-data-provider.service';

@Component({
  selector: 'app-visa-helper',
  templateUrl: './visa-helper.component.html',
  styleUrls: ['./visa-helper.component.css']
})
export class VisaHelperComponent implements OnInit,OnDestroy {
  pollingSubscription!: Subscription;

  visaPipelineSteps: any[];
  visaSteps: any[];
  requiredDocuments: any[];
  locations: any[];
  lat: number = 48.8566; // Example coordinates for Paris
  lng: number = 2.3522;
  zoom: number = 6;

  introA = 'Nuestro objetivo es facilitarte el camino para que puedas enfocarte en tu educación y experiencia en este hermoso país. No dudes en explorar esta sección para obtener información detallada y asesoramiento personalizado sobre las visas de estudiante en España.';

  cardProduct17 = {};
  cardProduct1 = {};
  sectionQueEsVisado = {};
  sectionRequisitosVisado = {};
  guiaAvanzadaVisado = {}
  notasImportantes = {};
  faqSection = {
    title: 'FAQs',
    array:  [
      { title: null, array: [] },
      { title: null, array: [] },
      { title: null, array: [] }
    ]
  }

  requisitosVisado = {};
  conectandoConLaU = {};
  checks = {};
  introSection = {};

  descripcionVisado = {
    cardId: 'A',
    imageUrl: this.guiFlow.getImage('ffd61471-34b1-43da-4cc2-cd3748415a00','public'),
    imageSize: 'sm',
    title: '¿Qué es el Visado de estudiante?',
    longPar: 'Es un permiso que autoriza a ciudadanos de otros países a residir legalmente en España con el propósito específico de realizar estudios en instituciones educativas reconocidas, ya sea en programas de grado, posgrado u otros cursos académicos.',
    longParLimit: '250',
    shortPara: '',
    description: 'Este visado otorga el derecho de permanecer en el país durante el periodo de estudios y exige una serie requisitos específicos de las autoridades españolas.',
    listData: [
      {
        subtitle: 'Plazos:',
        text: 'La solicitud del visado de estudiante se realiza en la embajada de España. Es importante estar al tanto de que el procedimiento se puede comenzar cuando falten 3 meses para realizar el viaje.'
      }
    ]
  };

  requisitosEmbajada = {
    cardId: 'A',
    title: 'Requisitos embajada de España en Costa Rica',
    subtitle: '',
    buttonText: 'Go to embajada',
    link: 'https://www.exteriores.gob.es/es/ServiciosAlCiudadano/Paginas/Servicios-consulares.aspx?scco=Costa+Rica&scd=252&scca=Visados&scs=Visados+Nacionales+-+Visado+de+estudios',
    array: [
      {
        title: 'Lista de requisitos oficiales',
        subtitle: 'Enlace los requisitos de la embajada de España',
        description: 'Aquí tienes el enlace a los requisitos del visado de estudios tal y como los expone la embajada de España en Costa Rica.',
        link: 'https://www.exteriores.gob.es/es/ServiciosAlCiudadano/Paginas/Servicios-consulares.aspx?scco=Costa+Rica&scd=252&scca=Visados&scs=Visados+Nacionales+-+Visado+de+estudios',
        linkLabel: 'Link requisitos'
      }
    ]
  }

  sections = [];

  @ViewChild('intro') intro: ElementRef<HTMLDivElement>;
  @ViewChild('primerospasos') primerospasos: ElementRef<HTMLDivElement>;
  @ViewChild('requisitos') requisitos: ElementRef<HTMLDivElement>;
  @ViewChild('notas') notas: ElementRef<HTMLDivElement>;
  @ViewChild('visado') visado: ElementRef<HTMLDivElement>;
  @ViewChild('faqs') faqs: ElementRef<HTMLDivElement>;

  constructor(private guiFlow: GuiFlowService,private router: Router,private resolver: ResolverService,private shopifyService: ShopifyService,private ordersService: OrdersService,private apiConnector: ApiConnectorService,private visaDataProvider: VisaDataProviderService) {
    this.introSection = this.visaDataProvider.getIntro();
    this.conectandoConLaU = this.visaDataProvider.getConectandoConLaU();

    this.cardProduct17['title'] = 'Primeros pasos para elegir la Universidad';
    this.cardProduct17['text'] = 'Estos son algunos de los puntos en los que te podremos ayudar cuando tengas ganas de comenzar con tu proceso de encontrar el plan de estudios más adecuado para ti.';
    this.cardProduct17['cta'] = 'Acceder al contenido';
    this.cardProduct17['imageUrl'] = 'https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/3552a26a-7946-4dd7-8ac4-ec2116c11200/public'; // <!-- Photo by <a href="https://unsplash.com/@domlafou?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Dom Fou</a> on <a href="https://unsplash.com/photos/people-sitting-on-chair-in-front-of-computer-YRMWVcdyhmI?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->
    this.cardProduct17['array'] = this.conectandoConLaU['dataArray'];
    this.cardProduct17['listValue'] = 'description';
    this.cardProduct17['iconSize'] = this.conectandoConLaU['iconSize'];
    this.cardProduct17['productVariantId'] = '17';
    
    // QUE ES EL VISADO
    this.sectionQueEsVisado['title'] = '¿Qué es el visado de estudiante?';
    this.sectionQueEsVisado['category'] = 'Estudiar en España';
    this.sectionQueEsVisado['category'] = 'Estudiar en España';
    this.sectionQueEsVisado['array'] = this.descripcionVisado.listData;
    this.sectionQueEsVisado['imageUrl'] = this.descripcionVisado.imageUrl;
    this.sectionQueEsVisado['text'] = this.descripcionVisado.longPar;
    this.sectionQueEsVisado['description'] = this.descripcionVisado.description;

    // REQUISITOS PARA VISADO
    this.requisitosVisado = this.visaDataProvider.getRequisitosVisados();
    this.sectionRequisitosVisado['array'] = this.requisitosVisado['dataArray'];
    this.sectionRequisitosVisado['title'] = 'Requisitos para obtener el visado';
    this.sectionRequisitosVisado['fieldForTitle'] = 'title';
    this.sectionRequisitosVisado['fieldForContent'] = 'description';
    // REQUISITOS PARA VISADO
    this.cardProduct1['title'] = 'Requisitos para obtener el visado';
    this.cardProduct1['text'] = 'Accede a la guía avanzada de los requisitos para obtener el visado de estudios.';
    this.cardProduct1['cta'] = 'Acceder al contenido';
    this.cardProduct1['cardId'] = 'A';
    this.cardProduct1['productVariantId'] = 54;

    // NOTAS IMPORTANTES
    this.checks = this.visaDataProvider.getChecks();
    this.notasImportantes['title'] = 'Notas importantes';
    this.notasImportantes['subtitle'] = 'Algunos detalles que no se te pueden escapar';
    this.notasImportantes['array'] = this.checks['dataArray'];

    //
    
    this.faqSection.array[0]['subtitle'] = 'Preguntas frecuentes';
    this.faqSection.array[0]['array'] = [
      { question: 'How long does the visa process take?', answer: 'The processing time varies by country, but it generally takes between 2 to 6 weeks.' },
      { question: 'What should I do if my visa application is denied?', answer: 'You can appeal the decision or reapply with additional supporting documents.' },
      { question: 'Can I expedite my visa application?', answer: 'Some countries offer expedited processing for an additional fee.' },
      {
        question: 'What is the purpose of the app?',
        answer: 'The purpose of the app is to provide users with a convenient and efficient way to access various services on their mobile devices.'
      },
      {
        question: 'Is the app free to download?',
        answer: 'Yes, the app is free to download from the app store.'
      },
      {
        question: 'Can I make payments through the app?',
        answer: 'Yes, the app supports various payment methods for your convenience.'
      }
    ];
    
    this.faqSection.array[0]['fieldForTitle'] = 'question';
    this.faqSection.array[0]['fieldForContent'] = 'answer';
    //
    this.faqSection.array[1]['subtitle'] = 'Payments & Subscription';
    this.faqSection.array[1]['array'] = [
      {
        question: 'What payment methods do you accept?',
        answer: 'We accept all major credit and debit cards, as well as payment services like PayPal and Apple Pay. You can also use gift cards or promotional codes, if available.'
      },
      {
        question: 'Are in-app purchases refundable?',
        answer: 'In-app purchases are generally non-refundable, but we may make exceptions in certain circumstances, such as if there was a technical issue or if the purchase was made by mistake. Please contact our support eligible for a refund.'
      },
      {
        question: 'How do I cancel a subscription?',
        answer: 'You can cancel a subscription at any time by going to your account settings and selecting the option to cancel. Please note that cancelling a subscription does not result in a refund for any remaining time left in the current billing cycle. */'
      }
    ];
    this.faqSection.array[1]['fieldForTitle'] = 'question';
    this.faqSection.array[1]['fieldForContent'] = 'answer';
    //
    this.faqSection.array[2]['subtitle'] = 'Privacy & Secruity';
    this.faqSection.array[2]['array'] = [
      {
        question: 'What information do you collect from users?',
        answer: 'We only collect the information necessary to provide our service to you, such as your name, email address, and payment information. We do not sell or share your information with third parties, except as required by law or to provide our service to you.'
      },
    ];
    this.faqSection.array[2]['fieldForTitle'] = 'question';
    this.faqSection.array[2]['fieldForContent'] = 'answer';

    this.guiaAvanzadaVisado['title'] = 'Guía avanzada para obtener el visado';
    this.guiaAvanzadaVisado['text'] = 'Te guiaremos durante todo el proceso para asegurar que consigas el visado de estudios.'
    this.guiaAvanzadaVisado['moreDetailsActive'] = false;
    this.guiaAvanzadaVisado['moreDetailsButton'] = 'Ver detalles';
    this.guiaAvanzadaVisado['premiumText'] = '';
    this.guiaAvanzadaVisado['premiumButton'] = 'Comprar guía';
    this.guiaAvanzadaVisado['productVariantId'] = '1';

    this.sections = [
      { id: 'intro', data: null, visible: true },
      { id: 'primerospasos', data: this.cardProduct17, visible: true },
      { id: 'visado', data: this.sectionQueEsVisado, visible: true },
      { id: 'requisitos', data: this.sectionRequisitosVisado, visible: true },
      { id: 'notas', data: this.notasImportantes, visible: true},
      { id: 'faqs', data: this.faqSection, visible: true}
    ];
  }

  ngOnInit(): void {
    
    this.locations = [
      { lat: 48.8566, lng: 2.3522, label: 'A' }, // Paris
      { lat: 50.8503, lng: 4.3517, label: 'B' }, // Brussels
      { lat: 51.5074, lng: -0.1278, label: 'C' }  // London
    ];
  }

  ngOnDestroy() {
    // Unsubscribe polling when leaving the page
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
    }
  }

  isProductIdActive(id){
    // Iterate through each object in the array
    let myArray = this.resolver.getDependency('getClientTools');
    myArray.records? myArray = myArray.records : null;
    for (let i = 0; i < myArray.length; i++) {
      // Check if the FK_ID_product matches the param value
      if (this.resolver.getDependency('getClientTools').records[i].FK_ID_product == id) {
        return this.resolver.getDependency('getClientTools').records[i].active == '1'; // If a match is found, return true
      }
    }
  return false; // If no match is found, return false
  }

  goToUrl(link){
    debugger
  }

  openPdf(pdfId){
    this.router.navigateByUrl('pdf-view/'+pdfId);
  }

  openAction(action){
    debugger;
  }

  scrollIntoView(selection): void {
    if(selection && selection.id){
      switch(selection.id){
        case 'intro':
          this.intro.nativeElement.scrollIntoView({ behavior: 'smooth'});
          break;
        case 'primerospasos':
          this.primerospasos.nativeElement.scrollIntoView({ behavior: 'smooth'});
          break;
        case 'visado':
            this.visado.nativeElement.scrollIntoView({ behavior: 'smooth'});
            break;
        case 'requisitos':
          this.requisitos.nativeElement.scrollIntoView({ behavior: 'smooth'});
          break;
        case 'notas':
          this.notas.nativeElement.scrollIntoView({ behavior: 'smooth'});
          break;
        case 'faqs':
          this.faqs.nativeElement.scrollIntoView({ behavior: 'smooth'});
          break;
        default:
          this.intro.nativeElement.scrollIntoView({ behavior: 'smooth'});
          break;
      }
    }else{
      this.intro.nativeElement.scrollIntoView({ behavior: 'smooth'});
    }
  }

  buyProductOld(buyCta){
    // create an order object and set it to processing
    let orderObject = {};
    let clientDetails = this.ordersService.getClientInfo();
      // if user is logged in I can get the info first

      let newShopifyOrder = {
        status: 'processing',
        FK_ID_clientDetails: this.resolver.getSelectedClientId()? this.resolver.getSelectedClientId(): -1,
        orderCode: this.ordersService.generateOrderToken()
      };
      this.apiConnector.voyjaleasApiRequest('post','shopifyOrder',null,null,null,newShopifyOrder) /* this.commonFunctions.getSelectedClientId() */
      .subscribe(
          (response) => {
            if(response && response.OK){
              this.checkIsOrderProcessed(response.OK.records.orderCode);
              orderObject['clientDetails;'] = clientDetails;
              orderObject['id'] =  response.OK.records.id;
              orderObject['cta'] = buyCta;
              this.shopifyService.buyProduct(orderObject['cta']);
            }else{
              this.resolver.saveOrderStatus(newShopifyOrder.orderCode,'unpaid');
            }
          },
          (error) => {
            console.log(error);
          }
      );
      // GO TO SHOPIFY AND CHECKOUT
    
  }

  buyProduct(buyCta){
    this.ordersService.buyProduct(buyCta).subscribe({
      next: (response) => {
        if (response && response.OK) {
          console.log('Order created successfully:', response);
          this.checkIsOrderProcessed(response.OK.records.orderCode);
        } else {
          console.warn('Order creation failed:', response);
          // Handle case where API returns success: false
        }
      },
      error: (error) => {
        
        console.error('HTTP request failed:', error);
        if (error.status === 0) {
          console.error('Likely CORS error or Network issue');
        } else {
          console.error(`Error ${error.status}: ${error.message}`);
        }
      }
    })
  }

  getTableOfContentOps(){
    let res = [];
    for(let section of this.sections){
        !section.data? section.data = {} : null;
        !section.data.title? null : res.push(section);
    }
    return res;
  }

  checkIsOrderProcessed(orderId){
    let counter = 0;
    let status;
    this.pollingSubscription = interval(5000).subscribe(() => {
      if(counter<this.resolver.__MAX_ORDER_PROCESS_CHECKS()){
        this.resolver.checkOrderStatus(orderId);
        status = this.resolver.getOrderStatus(orderId);
        if(status == 'paid' || status == 'paymentPending'){
          this.pollingSubscription.unsubscribe();
          counter = 99;
        }
        counter++;
      }else{
        // max tries of checking after user started a buy
        this.resolver.saveOrderStatus(orderId,'unpaid');
        this.pollingSubscription.unsubscribe();
      }
    });
  }

  isOrderPaid(){
    let orderId = this.resolver.getOrderToken();
    return this.resolver.getOrderStatus(orderId) == 'paid';
  }

  getOrderStatus(){
    let orderId = this.resolver.getOrderToken();;
    return this.resolver.getOrderStatus(orderId);
  }

}

